import styled from 'styled-components';
import { Link as NavLink } from 'react-router-dom';
import { BLACK, ACTIVE_NAV } from '../../theme';

export const SignList = styled.div`
  width: 100%;
  background: white;
  flex-direction: column;
  background-color: #F5FDFE;
  overflow: hidden;
  height: ${(props) => props.openSignList ? `52.5rem` : `0`};

  * {
    transition: height 500ms ease;
  }
`;

export const Link = styled(NavLink)`
  width: 100%;
  font-size: 1rem;
  display: flex;
  align-items: center;
  color: #4a4a4a;
  text-decoration: none;
  padding: 0.6rem 0rem 0.6rem 3.1rem;
  border-bottom: solid 1px #E7EDEE;
  font-family: "PT Sans";

  background: ${(props) =>
    props.active === `true` ? ACTIVE_NAV : `transparent;`};

  font-weight: ${((props) => (props.active === `true` ? `700` : `400`))};
  &:hover {
    cursor: pointer;
    text-decoration: none;
    background-color: #E7F7F9;
  }
`;

export const AccordionTitleWrapper = styled.div`
  width: 100%;
  height: 4.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style-type: none;
  padding: 0 1.25rem;
  font-family: "Calistoga";
  color: ${BLACK};
  cursor: pointer;
  border-bottom: solid 1px #E7EDEE;
  font-size: 1rem;

  background: ${(props) =>
    props.active === `true` ? ACTIVE_NAV : `transparent;`};
  &:hover {
    background: #e4f3f3;
  }

  a {
    border-bottom: 1px lightgray solid;
  }
`;

export const HoroscopeIcon = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.625rem;
  fill: ${BLACK};
`;

export const HoroscopeTitle = styled.div`
  align-items: center;
  display: flex;
  height: 4.4rem;
`;

export const SignLineIcon = styled.div`
  width: 0.9rem;
  height: 0.9rem;
  margin-right: 1.25rem;

  .st0{fill: ${BLACK}; stroke: none}
`;

export const SignWrapper = styled.div`
  display: flex;
  align-items: center;
`;

